import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button, PopoverDialog, usePopoverDialog, Text } from '@frontend/design-system';

export const VerificationAnalysisPopoverTooltip = () => {
  const { t } = useTranslation('scheduleCalendarEvents');

  const popoverProps = usePopoverDialog({
    placement: 'bottom-end',
  });

  return (
    <>
      <Button
        variant='secondary'
        css={{ color: theme.colors.neutral50 }}
        size='small'
        iconName='info'
        {...popoverProps.getTriggerProps()}
      />
      <PopoverDialog {...popoverProps.getDialogProps()} css={{ width: theme.spacing(50) }}>
        <Text size='large' weight='bold'>
          {t('Verification Analysis')}
        </Text>
        <Text css={{ marginTop: theme.spacing(1) }}>
          {t(
            'Breakdown of all insurance verifications by status, including auto-verified, manually verified, unverified, and errors, to help identify workflow efficiency and coverage gaps.'
          )}
        </Text>
      </PopoverDialog>
    </>
  );
};
